import * as toastr from 'toastr';

export const showSuccessMessage = (success, options = {}, custom = false) => {
  if (typeof success === 'string' || custom) {
    return toastr.success(success, '', { ...options });
  }
};
